export const reduxKey = '@@BI';
export const actionKey = '@@BI';
